import React from "react";
import Select from "react-select";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import useFilter from "./useFilter";

const Filter = () => {
  const { formik, shopList, supplierList, itemTypeList, handleReset } =
    useFilter();

  return (
    <div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="shop" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Shop
        </label>
        <Select
          id="shop"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          name="shop"
          isMulti
          options={shopList}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) =>
            option?.location
              ? `${option?.name} (${option?.location})`
              : option?.name
          }
          value={shopList?.filter((p) => formik.values.shop?.includes(p?._id))}
          onChange={(value) =>
            formik.setFieldValue("shop", value?.map((v) => v?._id) ?? [])
          }
          menuPlacement="auto"
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="supplier"
          className="pro-font-sm pro-mb-1 pro-fw-medium"
        >
          Supplier
        </label>
        <Select
          id="supplier"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          name="supplier"
          isMulti
          options={supplierList}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) =>
            option?.location
              ? `${option?.name} (${option?.location})`
              : option?.name
          }
          value={supplierList?.filter((p) =>
            formik.values.supplier?.includes(p?._id)
          )}
          onChange={(value) =>
            formik.setFieldValue("supplier", value?.map((v) => v?._id) ?? [])
          }
          menuPlacement="auto"
        />
      </div>

      <div className="input-wrap pro-mb-4">
        <label
          htmlFor="item_type"
          className="pro-font-sm pro-mb-1 pro-fw-medium"
        >
          Item Type
        </label>
        <Select
          id="item_type"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          name="item_type"
          isMulti
          options={itemTypeList}
          getOptionValue={(option) => option?._id}
          getOptionLabel={(option) => option?.name}
          value={itemTypeList?.filter((p) =>
            formik.values.item_type?.includes(p?._id)
          )}
          onChange={(value) =>
            formik.setFieldValue("item_type", value?.map((v) => v?._id) ?? [])
          }
          menuPlacement="auto"
        />
      </div>

      <div
        className={`col-12 pro-d-flex pro-justify-end ${"offcanvas-footer-sticky-btn"}`}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleReset}>
          Reset
        </Button>

        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default Filter;
